export enum FetchDocumentsReasonEnum {
    INITIALIZE = 'INITIALIZE',
    LOAD_MORE = 'LOAD_MORE',
    FILTER = 'FILTER',
}